
import { Suspense, useEffect, useState } from 'react'
import {
  Routes,
  Route,
  useNavigate,
} from 'react-router-dom'

import MetaTags from './Components/MetaTags'

import { MainRoutes } from './Constants/routes'
import Pagenotfound from './Views/StaticSite/Components/404 Error'
// import ReactGA from 'react-ga'
import ReactGA from 'react-ga4';

import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import { NavigationProvider } from './NavigationContext'
import { restoreTokensFromCookies, getAuthToken, getRefreshToken } from './authHelper'
import { loginUserSuccess } from './Views/StaticSite/Views/Authentication/Auth.actions'
import axios from 'axios'
import { authBaseDomain } from './Constants/appSettings'
import { handleAlreadySignedUpUser, handleAlreadySignedUpUserEmail } from './CleverTap/buttonClicked'



const App = () => {
  const [isVisible, setIsVisible] = useState(true);
  const location = useLocation();
  const nameFromRedux = useSelector((state) => state.auth.user.data?.firstName);
  const userData = useSelector((state) => state.auth.user?.data);
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    // const hasAcceptedCookies = localStorage.getItem('cookiesAccepted');
    // if (hasAcceptedCookies === "true" || hasAcceptedCookies === true) {
    //   setIsVisible(false);
    //   ReactGA.initialize('G-KZMLSTPLP1', { debug: true })
    //   console.log("react GA from cookies ", ReactGA);
    //   ReactGA.pageview('/')
    // }
    // ReactGA.initialize('G-KZMLSTPLP1')
    // ReactGA.send('/')
    if ((nameFromRedux && location.pathname == "/user/sign-in")) {//if user navigating to sigin and logged in then redirect to home
      navigate('/')
    }
  }, [location]);

   // 🔹 Step 1: Restore tokens from cookies if missing in localStorage
   useEffect(() => {
    restoreTokensFromCookies();
  }, []);

   // ✅ Step 2: Redirect user from login to home if already logged in
   useEffect(() => {
    const token = getAuthToken();
    const refreshToken = getRefreshToken();

    // If user is logged in and still navigates to sign-in, redirect dynamically
    if (token && location.pathname === "/user/sign-in") {
      // Ensure tokens are stored in localStorage (from cookies if needed)
      if (token && !localStorage.getItem('authorizationToken')) {
        localStorage.setItem('authorizationToken', token);
      }
      if (refreshToken && !localStorage.getItem('refreshToken')) {
        localStorage.setItem('refreshToken', refreshToken);
      }

      // Helper function to determine redirect path
      const getRedirectPath = () => {
        const searchParams = new URLSearchParams(location.search);
        
        // Priority 1: Check for returnUrl parameter (full path)
        const returnUrl = searchParams.get('returnUrl');
        if (returnUrl) {
          return returnUrl;
        }

        // Priority 2: Check for redirect parameter (full path)
        const redirect = searchParams.get('redirect');
        if (redirect) {
          return redirect;
        }

        // Priority 3: Check for location parameter (course names or special locations)
        const locationParam = searchParams.get('location');
        if (locationParam) {
          // Handle special location cases
          if (locationParam === 'shop') {
            return '/shop';
          }
          if (locationParam === 'blog_comment') {
            const returnUrl = searchParams.get('returnUrl');
            return returnUrl || '/blogs';
          }
          if (locationParam === 'cart') {
            return '/shop/checkout';
          }
          // For course names (e.g., single-consultation, extended-consultation), redirect to /enrollment/{courseName}
          return `/enrollment/${locationParam}`;
        }

        // Fallback: Default to home
        return '/';
      };

      // If user data already exists in Redux, just redirect without fetching
      if (userData && userData.firstName) {
        const redirectPath = getRedirectPath();
        console.log("✅ User data exists, redirecting to:", redirectPath);
        // Use setTimeout to ensure React has processed any state updates
        setTimeout(() => {
          navigate(redirectPath);
        }, 100);
        return;
      }

      // Fetch user details and update Redux state
      const getUserDetails = async () => {
        try {
          const response = await axios.get(`${authBaseDomain}/user/me`, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          
          if (response?.data?.data?.phoneNumber) {
            handleAlreadySignedUpUser({
              phone: response?.data?.data?.phoneNumber,
              dialCode: response?.data?.data?.dialCode
            });
          } else if (response?.data?.data?.email) {
            handleAlreadySignedUpUserEmail(response?.data?.data?.email);
          }
          
          localStorage.setItem('userAppId', response?.data.data?._id);
          
          // Update user details to Redux
          dispatch(loginUserSuccess({ type: 'auth/LOGIN_USER_SUCCESS', data: response?.data?.data }));
          
          // Wait a bit for Redux state to update before redirecting
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve();
            }, 200);
          });
        } catch (error) {
          console.error('Error fetching user data:', error);
        }
      };

      // Call getUserDetails and then redirect
      getUserDetails().then(() => {
        const redirectPath = getRedirectPath();
        console.log("✅ User details fetched, redirecting to:", redirectPath);
        navigate(redirectPath);
      });
    }
  }, [location, dispatch, navigate, userData]);

  const handleAccept = () => {
    // sessionStorage.setItem('cookiesAccepted', 'true');
    localStorage.setItem('cookiesAccepted', 'true');
    setIsVisible(false);
    ReactGA.initialize('G-KZMLSTPLP1')
    ReactGA.send('/')
  };
  const handleClose = () => {
    setIsVisible(false);
  };

  const clevertap = window?.clevertap;

  useEffect(() => {
    // Function to handle website exit event
    const handleWebsiteExit = () => {
      const currentPageUrl = window.location.href;

      // Trigger the CleverTap event for website exit
      clevertap.event.push("website_exit", {
        "Page_Url": currentPageUrl,
        "exit_timestamp": new Date().toISOString()
      });

      console.log("Website Exit Event Triggered");
    };

    // Add event listener for the 'beforeunload' event
    window.addEventListener('beforeunload', handleWebsiteExit);

    // Clean up when the component unmounts
    return () => {
      window.removeEventListener('beforeunload', handleWebsiteExit);
    };
  }, [location]);  // Run effect when location changes (navigation)


  // App.js or index.js

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('../public/clevertap_sw') // The service worker file hosted in public folder
        .then(function (registration) {
          console.log('Service Worker registered with scope:', registration.scope);
        })
        .catch(function (error) {
          console.error('Service Worker registration failed:', error);
        });
    }
  }, []);


  return (
    <Suspense fallback={<div className='global-loader' >Loading...</div>} >
      <MetaTags />
      <NavigationProvider>
      <Routes>
        {MainRoutes.map(({ Component, path }) => {
          return <Route element={<Component />} path={path} key={path} />
        })}
        <Route path='*' element={<Pagenotfound />} />
      </Routes>

      {/* badge to accept cookies */}
      {/* {isVisible && <div className="cookie-banner">
        <p>
          We use cookies to enhance your experience. By continuing to visit this site, you agree to our use of cookies.
        </p>
        <div>
          <button onClick={handleClose} className="cookie-button cancel-cookie">
            Close
          </button>
          <button onClick={handleAccept} className="cookie-button">
            Accept
          </button></div>
      </div>} */}
      </NavigationProvider>
    </Suspense>
  )
}

export default App
